// Cognito configuration — values will be set after deployment
export const AUTH_CONFIG = {
  userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
  clientId: process.env.REACT_APP_CLIENT_ID || '',
  domain: process.env.REACT_APP_COGNITO_DOMAIN || '',
  redirectUri: window.location.origin,
  logoutUri: window.location.origin,
};
